import React, { useState, useContext } from "react";
import { Backdrop, Box, Button, CircularProgress, Link, Typography } from "@mui/material";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import ConfigContext from "../../common/context/ConfigContext";

export default function StripePaymentElement(props) {
  const siteConfig = useContext(ConfigContext);

  const { amount, disabled, validate, returnUrl, showPolicy } = props;

  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState("");

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const isValid = await validate();

    // update client payment intent
    console.log("update payment intent");
    await elements.fetchUpdates();

    if (isValid) {
      setProcessing(true);

      console.log("confirmPayment");
      stripe
        .confirmPayment({
          elements,
          confirmParams: {
            return_url: returnUrl
          }
        })
        .then(function (result) {
          if (result.error) {
            setError(result.error.message);
            setProcessing(false);
          }
        });
    }
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement options={{ paymentMethodOrder: ["apple_pay", "google_pay", "card"], business: { name: siteConfig.biz || "" } }} />
      {showPolicy && (
        <Box mt={1} mb={2}>
          <Typography variant="caption" color="textSecondary" gutterBottom>
            By selecting the button below, I agree to all the{" "}
            <Link underline="always" href="#store-policy">
              Store Policies
            </Link>
            {" "}shown below.
          </Typography>
        </Box>
      )}
      <Box align="center" my={1}>
        {/* Show any error that happens when processing the payment */}
        {error && <Typography color="error">{error}</Typography>}
      </Box>
      <Button size="large" type="submit" color="primary" variant="contained" fullWidth disabled={processing || succeeded || disabled}>
        {`Pay ${amount}`}
      </Button>
      {processing && (
        <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </form>
  );
}
